import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const HASH_SCROLL_HEADER_OFFSET = 100;
/** Extra frames to wait for route content (e.g. long Terms page) before giving up */
const HASH_SCROLL_MAX_FRAMES = 80;

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      return;
    }

    const elementId = hash.replace('#', '');
    let frame = 0;
    let rafId = 0;
    let cancelled = false;

    const scrollToTarget = (): boolean => {
      const targetElement = document.getElementById(elementId);
      if (!targetElement) return false;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - HASH_SCROLL_HEADER_OFFSET;
      window.scrollTo({
        top: Math.max(0, offsetPosition),
        left: 0,
        behavior: 'auto',
      });
      return true;
    };

    const tick = () => {
      if (cancelled) return;
      if (scrollToTarget()) return;
      frame += 1;
      if (frame < HASH_SCROLL_MAX_FRAMES) {
        rafId = window.requestAnimationFrame(tick);
      } else {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    };

    rafId = window.requestAnimationFrame(tick);

    return () => {
      cancelled = true;
      window.cancelAnimationFrame(rafId);
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
